/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResultResponse } from './ResultResponse';
import {
    ResultResponseFromJSON,
    ResultResponseFromJSONTyped,
    ResultResponseToJSON,
    ResultResponseToJSONTyped,
} from './ResultResponse';

/**
 * 
 * @export
 * @interface AssessmentResultResponse
 */
export interface AssessmentResultResponse {
    /**
     * 
     * @type {string}
     * @memberof AssessmentResultResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResultResponse
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResultResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResultResponse
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResultResponse
     */
    oscalVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResultResponse
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResultResponse
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssessmentResultResponse
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssessmentResultResponse
     */
    updated?: Date;
    /**
     * 
     * @type {Array<ResultResponse>}
     * @memberof AssessmentResultResponse
     */
    results?: Array<ResultResponse>;
}

/**
 * Check if a given object implements the AssessmentResultResponse interface.
 */
export function instanceOfAssessmentResultResponse(value: object): value is AssessmentResultResponse {
    return true;
}

export function AssessmentResultResponseFromJSON(json: any): AssessmentResultResponse {
    return AssessmentResultResponseFromJSONTyped(json, false);
}

export function AssessmentResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'version': json['version'] == null ? undefined : json['version'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'status': json['status'] == null ? undefined : json['status'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(ResultResponseFromJSON)),
    };
}

export function AssessmentResultResponseToJSON(json: any): AssessmentResultResponse {
    return AssessmentResultResponseToJSONTyped(json, false);
}

export function AssessmentResultResponseToJSONTyped(value?: AssessmentResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'version': value['version'],
        'oscalVersion': value['oscalVersion'],
        'documentId': value['documentId'],
        'status': value['status'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(ResultResponseToJSON)),
    };
}

